import Swiper from "swiper";
import { breakpoints } from "./config";
import bb from 'blingblingjs';


// MOBILE
const breakpointMob = window.matchMedia(`(max-width:${breakpoints.l}px)`);

let mySwiperMob;

const breakpointCheckerMob = function() {
    if (breakpointMob.matches === true) {
        return enableSwiperMob();
    } else if (breakpointMob.matches === false) {
        if (Array.isArray(mySwiperMob)) mySwiperMob.forEach(swiper => swiper.destroy(true, true));
        else mySwiperMob !== undefined && mySwiperMob.destroy(true, true)
        return;
    }
};

const enableSwiperMob = function() {
    bb(".js-el__mobile-content-carousel").forEach(el => {

        const scrollbar = bb('.js-el__mobile-content-carousel__scrollbar', el);

        const defaultConfig = {
            slidesPerView: "auto",
            //freeMode: true,
            slideClass: "mobile-carousel-slide",
            wrapperClass: "mobile-carousel-wrapper",
            observeParents : true,
            observer: true
        }

        const scrollbarConfig = {
            scrollbar: {
                el: ".js-el__mobile-content-carousel__scrollbar",
                hide: false,
                draggable: true,
                dragSize: 180
            }
        }

        const config = scrollbar.length > 0 ? 
        {   
            ...defaultConfig,
            ...scrollbarConfig
            
        } : defaultConfig


        mySwiperMob = new Swiper(".js-el__mobile-content-carousel", config);

        console.log(config)
    })
    
};

breakpointMob.addListener(breakpointCheckerMob);
breakpointCheckerMob();





